import { settings } from 'config';

export type Experience = 'default' | 'AMK' | 'SEI';

export const isSeiExperience = (): boolean => settings.app.experience === 'SEI';

export const isAmkExperience = (): boolean => settings.app.experience === 'AMK';
